module.exports = __webpack_public_path__ + "static/media/twilight-ipad.fe6e9472.jpg";